import { plataforma } from '@/platform';
import type { Metodo } from '@/platform';

export type ApiError = {
  codigo: string;
  mensagem: string;
  tipo: string;
};

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly payload: ApiError | null,
  ) {
    super(payload?.mensagem ?? `Falha na requisição (${status})`);
  }
}

function dividirCaminhoQuery(caminho: string): { caminho: string; query: Record<string, string> } {
  const idx = caminho.indexOf('?');
  if (idx === -1) return { caminho, query: {} };
  const base = caminho.slice(0, idx);
  const usp = new URLSearchParams(caminho.slice(idx + 1));
  const query: Record<string, string> = {};
  usp.forEach((v, k) => {
    query[k] = v;
  });
  return { caminho: base, query };
}

/**
 * Ponto único de chamada de dados da UI. Quem resolve é a plataforma:
 * IPC no desktop, HTTP no web. As telas não sabem a diferença.
 */
async function request<T>(metodo: Metodo, caminho: string, corpo?: unknown): Promise<T> {
  const { caminho: caminhoLimpo, query } = dividirCaminhoQuery(caminho);

  const resposta = await plataforma.request({ metodo, caminho: caminhoLimpo, corpo, query });

  if (resposta.status >= 400) {
    const erro = 'erro' in resposta ? resposta.erro : null;
    throw new HttpError(resposta.status, erro);
  }
  if (resposta.status === 204) return undefined as T;
  return ('corpo' in resposta ? resposta.corpo : undefined) as T;
}

export const httpClient = {
  get: <T,>(caminho: string) => request<T>('GET', caminho),
  post: <T,>(caminho: string, corpo: unknown) => request<T>('POST', caminho, corpo),
  put: <T,>(caminho: string, corpo: unknown) => request<T>('PUT', caminho, corpo),
  delete: <T,>(caminho: string) => request<T>('DELETE', caminho),
};
